import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-islamic-library',
  imports: [PagePlaceholderComponent],
  templateUrl: './islamic-library.component.html',
  styleUrl: './islamic-library.component.scss'
})
export class IslamicLibraryComponent {
  protected readonly icon = '📚';
  protected readonly pageTitle = 'pages.islamic_library.title';
  protected readonly subtitle = 'pages.islamic_library.subtitle';
}
